import { useLocation, Navigate, Outlet } from "react-router"
import {useSelector} from "react-redux"
import { selectCurrentToken } from "./authSlice"

const RequireAuth = () => {
    const token = useSelector(selectCurrentToken)
    // console.log(token)
    const location = useLocation()
    
  return (
    token 
    ? <Outlet/>
    : <Navigate to="/pages/login/login3" state={{from : location}} replace />
  )
}

export default RequireAuth